import type { PersonChannel } from '../../entities/personChannel/personChannelTypes';
import { MOCK_GROUP_ID } from './mockSite';

const audit = {
  companyId: 1,
  groupId: MOCK_GROUP_ID,
  userId: 1,
  userName: 'Sistema',
  createDate: '2026-01-10T10:00:00Z',
  modifiedDate: '2026-01-10T10:00:00Z',
};

/**
 * Lookup mock per PersonChannel (clone esatto di mockPersonSources).
 * I nomi qui corrispondono 1:1 ai valori usati come stringa libera nei
 * mockPersons. L'array è mutabile: il handler MSW POST/PATCH
 * /people/:groupId fa append in caso di find-or-create.
 */
export const mockPersonChannels: PersonChannel[] = [
  { personChannelId: 1, name: 'Sito web', ...audit },
  { personChannelId: 2, name: 'Fiera Hannover 2026', ...audit },
  { personChannelId: 3, name: 'Passaparola', ...audit },
  { personChannelId: 4, name: 'Telefono', ...audit },
  { personChannelId: 5, name: 'LinkedIn', ...audit },
];

let nextPersonChannelId = 6;

export function consumeNextPersonChannelId(): number {
  return nextPersonChannelId++;
}
